import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import styles from "./AdminCompanyNav.scss";

class AdminCompanyNav extends Component {
  render() {
    const { id, projectsCount } = this.props;

    return (
      <div className={styles.detailNav}>
        <div className={styles.header}>
          <div className={styles.detailNavLink}>
            <NavLink
              activeClassName={styles.active}
              exact
              to={`/admin/company/${id}`}
            >
              Company Profile
            </NavLink>
          </div>
          <div className={styles.detailNavLink}>
            <NavLink
              activeClassName={styles.active}
              to={`/admin/company/${id}/projects`}
            >
              All Projects ({projectsCount})
            </NavLink>
          </div>
          <div className={styles.detailNavLink}>
            <NavLink
              activeClassName={styles.active}
              to={`/admin/company/${id}/billing`}
            >
              Billing
            </NavLink>
          </div>
        </div>
      </div>
    );
  }
}

export default AdminCompanyNav;



// WEBPACK FOOTER //
// ./src/routes/admin/company/components/AdminCompanyNav.js